import React, { useRef } from 'react';

interface UploadButtonProps {
    onFileSelect: (files: File[]) => void;
    accept?: string;
    multiple?: boolean;
}

export default function UploadButton({ onFileSelect, accept = '*', multiple = true }: UploadButtonProps) {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(event.target.files || []);
        if (files.length > 0) {
            onFileSelect(files);
        }
        // Limpa o input para permitir selecionar o mesmo arquivo novamente
        event.target.value = '';
    };

    return (
        <div className="upload-button-container" title='Selecionar Arquivos para Upload'>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept={accept}
                multiple={multiple}
                style={{ display: 'none' }}
            />
            <button
                className="upload-button"
                onClick={handleClick}
                type="button">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" /></svg>
            </button>
        </div>
    );
}

